import {
  FindAnExpert,
  getStaticProps,
} from '@public/Consultations/FindAnExpert'

export { getStaticProps }

export default FindAnExpert
